import { useEffect } from "react";
import { applyTheme, resolveTheme, useThemeStore } from "@/lib/theme";

/**
 * Keeps `<html class="dark">` in sync with the chosen theme, including
 * live system-preference changes while the theme is "system".
 */
export function useThemeEffect(): void {
  const mode = useThemeStore((s) => s.mode);

  useEffect(() => {
    applyTheme(mode);
    if (mode !== "system") return;

    const query = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => applyTheme("system");
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, [mode]);
}

export function useResolvedTheme() {
  const mode = useThemeStore((s) => s.mode);
  return resolveTheme(mode);
}
